import React from 'react';
import { Form, Input, Button } from 'antd';
import VideoUpload from './../courseform/elements/videoupload';
import Lecturefiles from '../editcoursecurriculum/files';

export default ({
  handleVideoChange,
  getFieldDecorator,
  sectionId,
  media,uploadMedia,
  uploadFile,removeFile,
  getMedia,
  refreshVideos,refresh,
  profile,
  lectureId,
  lecturesLength,
  removeLecture,
  lectureIndex,
  sectionIndex,
  lecture,

}) => (
  <div className="lecture-content">
    <Form.Item label="lecture title">
      {lecturesLength >= 2 ? (
        <Button
          onClick={() => removeLecture(sectionId, lectureIndex)}
          className="remove-lecture-btn"
          size="small"
          type="danger"
        >
          Remove Lecture
        </Button>
      ) : (
        ''
      )}
      {getFieldDecorator(`${sectionId}|title|${lectureId}`, {
        rules: [{ required: true, message: 'Please input your lecture title!' }]
      })(<Input placeholder="lecture title" name="title" size="default" />)}
    </Form.Item>
    
    <Form.Item label="Upload Lecture Video">
      <div className="upload-lecture">
        <VideoUpload
          media={media}
          uploadMedia={uploadMedia}
          refreshVideos={refreshVideos}
          refresh={refresh}
          getMedia={getMedia}
          profile={profile}
          getFieldDecorator={getFieldDecorator}
          handleVideoChange={videoUrl =>
            handleVideoChange(videoUrl, sectionId, lectureId)
          }
        />
      </div>
    </Form.Item>
    <div className="add-lecfile">
        <Lecturefiles 
        profile={profile}
        uploadFile={uploadFile}
        files={lecture.files}
        removeFile={removeFile}
        lectureIndx={parseInt(lectureIndex)}
        sectionIndx={parseInt(sectionIndex)}
        />
      </div>
  </div>
);
